import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';
import { useError } from '@atlassian/ui-modifications-core/controllers';
import { errorCodeToErrorMessageMap } from './constants';

export const useUiModificationsErrors = () => {
	di(useError);
	const error = useError();
	const { formatMessage } = useIntl();
	const [errorMessage, setErrorMessage] = useState<string | null>(null);

	useEffect(() => {
		if (!error) {
			setErrorMessage(null);
		} else {
			const message = errorCodeToErrorMessageMap[error.errorCode];
			const formattedMessage = formatMessage(message);
			setErrorMessage(formattedMessage);
		}
	}, [error, formatMessage]);

	return errorMessage ? [{ message: errorMessage }] : [null];
};
